import { render, staticRenderFns } from "./MyCard.vue?vue&type=template&id=06760efb&"
import script from "./MyCard.vue?vue&type=script&lang=js&"
export * from "./MyCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports